import { render, staticRenderFns } from "./register.vue?vue&type=template&id=6a3a0a64&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=6a3a0a64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a0a64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\webapp_abroad\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3a0a64')) {
      api.createRecord('6a3a0a64', component.options)
    } else {
      api.reload('6a3a0a64', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=6a3a0a64&scoped=true&", function () {
      api.rerender('6a3a0a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/register.vue"
export default component.exports